<template>
  <div class="mt-5">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6" xl="4" lg="4">
          <v-card max-width="450" class="mx-auto">
            <v-img :src="heroInfo.summary.img" class="white--text align-end img-class"
                   position="top"
                   gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
              <v-card-title>
                <div class="d-flex justify-space-around positions-class">
                  <div v-for="(item,index) in heroInfo.summary.positions" class="positions-item-class" :key="index">
                    <v-sheet :color="position.toLowerCase() === item.name.toLowerCase() ? '#9c8250' :  '#1dbaa9'"
                             class="rounded">
                      <div
                          class="d-flex justify-space-around align-center positions-sheet-class py-2 px-1">
                        <div class="positions-sheet-img-class">
                          <img
                              :src="`https://s-lol-web.op.gg/static/images/icon/lol/position/position-${item.name.toLowerCase()}-over@2x.png`"
                              style="height: 100%;width: 100%" alt=""/>
                        </div>
                        <span class="positions-sheet-label-text text-overline d-none d-sm-flex text-center">{{
                            item.label
                          }}</span>
                        <span class="positions-sheet-winRate-class text-caption text-center">{{
                            item.roleRate
                          }}%</span>
                      </div>
                    </v-sheet>
                  </div>
                </div>
              </v-card-title>
            </v-img>
            <v-card-text>
              <!--技能-->
              <div class="d-flex justify-space-around">
                <div v-for="(item,index) in heroInfo.summary.spells" :key="index"
                     class="pr-2 d-inline-block">
                  <v-tooltip top color="#161a20">
                    <template v-slot:activator="{ on, attrs }">
                      <v-img :src="item.img" max-width="55" max-height="55"
                             v-bind="attrs"
                             v-on="on"
                             class="rounded white--text align-end text-center"
                             gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                        <span>{{ item.key }}</span>
                      </v-img>
                    </template>
                    <div class="px-3">
                      <span class="py-2" style="color:#b59758;">{{ item.name }}</span>
                      <v-divider light></v-divider>
                      <span class="py-2">{{ item.description }}</span>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- -->
        <v-col cols="12" md="6" xl="8" lg="8">
          <v-container>
            <v-row>
              <!--符文-->
              <v-col cols="12" xl="6" lg="6">
                <rune :hero-info="heroInfo"></rune>
              </v-col>


              <!-- 优劣 -->
              <v-col cols="12" xl="6" lg="6">
                <opponent :hero-info="heroInfo"></opponent>
              </v-col>


              <!--装备-->
              <v-col cols="12" xl="6" lg="6">
                <item :list="heroInfo.item.coreItem" title="核心装备"></item>
              </v-col>

              <!--鞋子-->
              <v-col cols="12" xl="6" lg="6">
                <item :list="heroInfo.item.boots" v-if="heroInfo.item.boots.length !== 0" title="鞋子"></item>
              </v-col>


            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Rune from '@/components/game/Rune'
import Opponent from '@/components/game/Opponent'
import Item from '@/components/game/Item'

export default {
  name: "Info",
  components: {
    Rune,
    Opponent,
    Item
  },
  props: {
    position: undefined,
    heroInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    tab: null,
    infoDialog: true,
  }),
  methods: {}
}
</script>

<style scoped>
.img-class {
  height: 600px;
}

.positions-class {
  width: 100%;
  height: 100%;
}

.positions-item-class {
  width: 30%;
}

.positions-sheet-class {
  width: 100%;
  height: 100%;
}

.positions-sheet-img-class {
  width: 20%;
  max-width: 24px;
  min-width: 24px;
  height: 24px;
}


.positions-sheet-winRate-class {
  width: 46%;
}

.positions-sheet-label-text {
  width: 30%;
}

</style>
